var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(20.8941 0 0 20.8941 185.1021 499.9998)",
    id: 752748
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(253,165,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4.9919, -9)",
    d: "M 3.98984 18 H 2.99143 L 3.98984 11 H 0.495416 C -0.0836591 11 -0.0736751 10.68 0.116022 10.34 C 0.305719 10 0.165942 10.26 0.185911 10.22 C 1.47385 7.94 3.41076 4.54 5.98665 0 H 6.98506 L 5.98665 7 H 9.48107 C 9.97029 7 10.0402 7.33 9.95032 7.51 L 9.88043 7.66 C 5.94671 14.55 3.98984 18 3.98984 18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.1574 0 0 18.1574 790.9491 499.9997)",
    id: 657840
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-9.2212, -9)",
    d: "M 16.7292 4.23 L 16.7392 4.22 L 13.0252 0.5 L 11.9668 1.56 L 14.0735 3.67 C 13.135 4.03 12.466 4.93 12.466 6 C 12.466 7.38 13.5843 8.5 14.9621 8.5 C 15.3215 8.5 15.651 8.42 15.9605 8.29 V 15.5 C 15.9605 16.05 15.5112 16.5 14.9621 16.5 C 14.4129 16.5 13.9637 16.05 13.9637 15.5 V 11 C 13.9637 9.9 13.0651 9 11.9668 9 H 10.9684 V 2 C 10.9684 0.9 10.0699 0 8.97162 0 H 2.98119 C 1.88294 0 0.984375 0.9 0.984375 2 V 18 H 10.9684 V 10.5 H 12.466 V 15.5 C 12.466 16.88 13.5843 18 14.9621 18 C 16.3399 18 17.4581 16.88 17.4581 15.5 V 6 C 17.4581 5.31 17.1785 4.68 16.7292 4.23 Z M 8.97162 7 H 2.98119 V 2 H 8.97162 V 7 Z M 14.9621 7 C 14.4129 7 13.9637 6.55 13.9637 6 C 13.9637 5.45 14.4129 5 14.9621 5 C 15.5112 5 15.9605 5.45 15.9605 6 C 15.9605 6.55 15.5112 7 14.9621 7 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8796 0 0 0.8796 467.3749 499.9965)",
    id: 109003
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-250, -302.6367)",
    d: "M 241.99219 407.91016 L 241.99219 310.44922 L 144.72656 310.44922 L 144.72656 294.43359 L 241.99219 294.43359 L 241.99219 197.36328 L 257.61719 197.36328 L 257.61719 294.43359 L 355.27344 294.43359 L 355.27344 310.44922 L 257.61719 310.44922 L 257.61719 407.91016 L 241.99219 407.91016 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhev);
export default __webpack_public_path__ + "static/media/PHEV.3b1292209713b6af1a7561af824ca350.svg";
export { ForwardRef as ReactComponent };